module.exports = __webpack_public_path__ + "assets/img/loading.9e0373c2.gif";